import {
  required,
} from 'vuelidate/lib/validators';

function isValidUrl(string) {
  if (!string) return true;
  try {
    const res = string.match(
      /(http:\/\/|https:\/\/)(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@\-\/]))?/, // eslint-disable-line no-useless-escape
    );
    return res !== null;
  } catch (err) {
    return false;
  }
}

const commonValidations = {
  title: {
    required,
  },
  description: {
    required,
  },
  redirection_url: {
    required: false,
    isValidUrl,
  },
};

export const mainHeadLineValidations = {
  ...commonValidations,
  display_date: {
    required,
  },
};

export const featuredContentValidations = {
  ...commonValidations,
  start_date: {
    required,
  },
  end_date: {
    required,
  },
};
